var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.form.ref)?_c('configure-product',{attrs:{"form":_vm.data.form,"type":"product"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }